<template>
    <span class="time">{{time}}</span>
</template>

<script>
import '@/styles/style.css';
export default {

  data() {
    return {
      time: '',
      clockTimer: null
    }
  },
  props: ["startTime", "endTime"],
  mounted() {
    // this.clockTimer = setInterval(() => this.getRemainTime(), 1000)
  },
  watch: {
    // 방송이 바뀌면(예약 승격 등) 새 시간으로 카운트다운을 다시 시작한다.
    // 이전 방송 종료로 타이머가 멈춰 있어도 여기서 되살아나므로
    // 방송 1 -> 2 -> 3 을 이어서 볼 때 시계가 "방송종료"에 고정되지 않는다.
    startTime() { this.restartOnairTimer() },
    endTime() { this.restartOnairTimer() }
  },
  beforeDestroy() {
    this.stopOnairTimer()
  },
  methods: {
    // "YYYY/M/D HH:mm" 파싱. 방송 정보가 비면 "2026/9/23 " 같은 값이 들어오는데
    // 이 문자열은 그날 자정으로 파싱돼 "이미 종료"로 오판된다.
    // 그래서 시각 부분이 실제로 붙어 있는지 먼저 확인한다.
    parseOnairTime(value) {
      const text = String(value === undefined || value === null ? '' : value).trim()
      if (text === '') return null
      if (!/\d{1,2}:\d{1,2}$/.test(text)) return null
      const date = new Date(text)
      return isNaN(date.getTime()) ? null : date
    },
    getRemainTime () {
      const startDate = this.parseOnairTime(this.startTime)
      const endDate = this.parseOnairTime(this.endTime)
      // 편성 정보가 없으면 표시만 비우고 기다린다.
      // 예전에는 이 경우에도 종료로 보고 퇴장시켜, 방송이 없을 때 접속하면 앱이 닫혔다.
      if (startDate === null || endDate === null) {
        this.time = ''
        this.stopOnairTimer()
        return
      }
      const now = new Date()
      // 시작 전. 예전에는 퇴장이었으나 이제는 대기 상태로 둔다.
      if (now < startDate) {
        this.time = "방송대기"
        return
      }
      const timeRemaining = endDate - now
      if (timeRemaining <= 0) {
        // 방송이 끝나도 내보내지 않는다. 퇴장은 서버가 지시할 때만 한다.
        // 다음 방송 정보가 내려오면 watch 가 타이머를 다시 켠다.
        this.time = "방송종료";
        this.stopOnairTimer()
        return;
      }
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      this.time = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },
    // 카운트다운을 돌릴 상태인지. 편성이 없거나 이미 끝났으면 1초 타이머가 필요 없다.
    shouldRunOnairTimer() {
      const startDate = this.parseOnairTime(this.startTime)
      const endDate = this.parseOnairTime(this.endTime)
      if (startDate === null || endDate === null) return false
      return (endDate - new Date()) > 0
    },
    startOnairTimer() {
      this.stopOnairTimer()
      // 첫 표시를 1초 기다리지 않도록 즉시 1회 계산한다.
      this.getRemainTime()
      if (!this.shouldRunOnairTimer()) return
      this.clockTimer = setInterval(() => this.getRemainTime(), 1000)
    },
    stopOnairTimer() {
      if (this.clockTimer !== null) {
        clearInterval(this.clockTimer)
        this.clockTimer = null
      }
    },
    // 방송 정보가 바뀌었을 때. startOnairTimer 가 편성 유무와 종료 여부를 모두 판단한다.
    restartOnairTimer() {
      this.startOnairTimer()
    }
  }
}
</script>
